import React from 'react'
import { Container, Button as _Button } from 'reactstrap'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { fontWeight } from 'themes/font'

export const Button = styled(_Button)`
  flex: 1;
  border: 0 !important;
  font-weight: ${fontWeight.bold} !important;
  text-transform: uppercase;
  span {
    display: block;
    &.info {
      font-size: 0.75rem;
      font-weight: ${fontWeight.medium};
      text-transform: none;
    }
  }
`

const Bottom = styled.div`
  width: 100%;
  background: #fff;
  box-shadow: 0 -16px 16px rgba(0,0,0,.05);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 16px 0;
  z-index: 1050;
  ${media.md`
    display: flex;
  `}
`

const ApplyNowRightStyled = styled.div`
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  .content {
    margin-bottom: 8px;
  }
  .buttons {
    flex: 1;
    display: flex;
    align-items: center;
    margin: 0px -4px;
    .info {
      display: none;
    }
    a {
      flex: 1;
      padding: 0px 4px;
    }
  }
  ${media.lg`
    flex-direction: row;
    align-items: center;
    .content {
      flex: 1;
      margin-bottom: 0;
    }
    .buttons {
      flex: 1;
      margin-left: 8px;
      margin-right: -8px;
      .info {
        display: block;
      }
      a {
        padding: 0px 8px;
      }
      button {
        height: 56px;
      }
    }
  `}
`

const ApplyNowRight = () => (
  <Bottom>
    <Container>
      <ApplyNowRightStyled>
        <div className='content'>
          Gởi Email đăng ký kèm CV với Tiêu đề: <strong>TTVN – Internship – Tên vị trí ứng tuyển</strong> về <a href='mailto:recruitment@tungtung.vn?subject=TTVN – Internship – [Tên vị trí ứng tuyển]' target='_blank' rel='noopener noreferrer'>recruitment@tungtung.vn</a> trước ngày 22/9/2019.
        </div>
        <div className='buttons'>
          <a href='mailto:recruitment@tungtung.vn?subject=TTVN – Internship – [Tên vị trí ứng tuyển]' style={{ flex: 1 }} target='_blank' rel='noopener noreferrer'>
            <Button block color={'primary'} style={{ flex: undefined }}>
              <span>Apply Now</span>
              <span className='info'>Email : recruitment@tungtung.vn</span>
            </Button>
          </a>
        </div>
      </ApplyNowRightStyled>
    </Container>
  </Bottom>
)

export default ApplyNowRight
